import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useStyles = makeStyles({
  storyBoardView: {
    display: 'flex',
    gap: '16px',
    height: '100%',
    minWidth: 'max-content',
    borderRadius: '10px',
    ...shorthands.padding(tokens.spacingVerticalMNudge),
    backgroundColor: '#FFFFFF',
  },
  templateContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '152px',
    backgroundColor: '#F0F0F0',
    borderRadius: '10px',
    paddingLeft: '10px',
  },
  templateThumbnail: {
    maxWidth: '125px',
    height: 'auto',
    borderRadius: '10px',
    fontSize: '14px',
  },
  templateText: {
    color: tokens.colorNeutralForeground3,
    fontSize: '14px',
  },

  scenesContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },

  sceneContainer: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: '8px',
  },

  sceneTitle: {
    fontSize: '16px',
    fontWeight: '500',
  },

  thumbnailsRow: {
    display: 'flex',
  },
  sceneItem: {
    display: 'flex',
    marginTop: '5px',
    marginLeft: '5px',
    flexDirection: 'column',
    maxWidth: '125px',
    height: 'auto',
    '& .scene-decorator': {
      borderRadius: '10px',
      '& .thumbnail': {
        overflow: 'hidden',
        '&.selected': {
          outlineColor: '#0078d4',
          outlineStyle: 'solid',
        },
        padding: 1,
      },
    },
  },
  sceneThumbnail: {
    height: '88px',
    borderRadius: '10px',
    marginBottom: '0px',
  },
  sceneNumber: {
    marginBottom: '16px',
    '& span': {
      verticalAlign: 'middle',
      lineHeight: '12px',
    },
  },
  audioBar: {
    display: 'flex',
    borderRadius: '10px',
    width: '100%',
    height: '28px',
    color: 'white',
    paddingTop: '2px',
    paddingLeft: '5px',
  },
  navigationContainer: {
    display: 'grid',
    marginLeft: '10px',
  },
});
